<template>
    <div v-if="loaded" class="reservations__schedule-block">
        <view-schedule
            :show-advanced="showAdvanced"
            :calculated-name="calculatedName"
            :select-color="selectColor"
            :mass-create="massCreate"
            :reservables="reservables"
            :groups="groups"
            :metas="metas"
            :schedule="schedule"
            :fields="fields"
            :domains="domains"
        ></view-schedule>
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import ViewSchedule from '@src/Reservations/Pages/Schedule/ViewSchedule.vue';

const loaded = ref(false);

const reservables = ref([]);
const groups = ref([]);
const metas = ref([]);
const schedule = ref([]);
const fields = ref({});
const domains = ref([]);
const showAdvanced = ref(false);
const selectColor = ref(false);
const massCreate = ref(false);
const calculatedName = ref(false);

const load = () => {
    axios.get(route('reservations/slots.admin.schedule.view')).then(({ data }) => {
        reservables.value = data.reservables;
        groups.value = data.groups;
        metas.value = data.metas;
        schedule.value = {
            from: data.start,
            to: data.end,
            group: data.group ?? 'day',
        };
        fields.value = data.fields;
        domains.value = data.domains;
        showAdvanced.value = data.advanced;
        selectColor.value = data.select_color;
        massCreate.value = data.mass_create;
        calculatedName.value = data.calculated_name;

        loaded.value = true;
    });
};

load();
</script>
